import { GridEventListener } from '@mui/x-data-grid';
import { FC } from 'react';
import { evaluate } from '../../../../evaluator';
import { useUiTemplate } from '../../../../hooks';
import { useNotableEvents } from '../../../../hooks/use-notable-events';
import { CLUSTER_TABLE_DEFAULT_TEMPLATE } from '../../../../ui-templates';
import { EventLocationData } from '../../thing-event-pane';

interface Props {
  data: EventLocationData[];
  onEventSelect?: GridEventListener<'rowClick'>;
}

export const ClusterTabularData: FC<Props> = ({ data, onEventSelect }) => {
  const notableEvents = useNotableEvents();
  const { template, loaded } = useUiTemplate('track-event-cluster-table', CLUSTER_TABLE_DEFAULT_TEMPLATE);
  return <>{evaluate(template, { loading: !loaded, data, onEventSelect, notableEvents })}</>;
};
